import React, { useState, useContext  } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'; 
import {upload_file} from '../../../../services/projectservice'
import { CenterContainer } from '../../../Template';
import { AuthContext } from '../../../../AuthContext';
import { JsonStrView } from '../../root/demo/demo_util';
import { CDN_URI } from '../../../../utils/appconfig';

export function Uploader({ handleComplete }) {

    const { authToken, claims, isLoading, onLogout } = useContext(AuthContext);
    const [status, setStatus] = useState('Not Started');  
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [uploadName, setUploadName] = useState('');
    // const [fileMetaData, setFileMetaData] = useState({}) 

    const onError = (error) => {
        setStatus(`Upload failed: ${error.toString()}`);
    }

    const onComplete = (response_data) => {
        console.log('Upload successful, server responded with: ' + JSON.stringify(response_data))   
        setStatus('Upload successful!');
        // setFileMetaData(response_data)
        handleComplete(response_data)
        // setFileId()
    }

    function handleFileChange(e) {
        // Get the selected file
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            // Create a local URL for the file to display a preview
            setPreviewUrl(URL.createObjectURL(selectedFile));
        }
    }

    const handleUpload = async () => {     
        console.log('handleUpload called with file: ' + file + ' and authToken: ' + authToken   )
        var uploadNameToUse = ''
        if (uploadName !== null && uploadName.trim() !== '') {
            uploadNameToUse = uploadName.trim()
        }
        if (file) {
            upload_file(file, uploadNameToUse, authToken, onComplete, onError);
        }
    }

    return (
        <div className="ImageUploader">
            <h2>Add Image:</h2>
            {/* Input element to select a file, accepts only image types */}
            <CenterContainer>
                <input type="file" 
                    accept="image/*" 
                    onChange={handleFileChange} />
            </CenterContainer>
            
            <CenterContainer>
                <label htmlFor="upload_name">Upload Name:</label>
                <input 
                    type="text" 
                    id="upload_name" 
                    value={uploadName} 
                    onChange={e => setUploadName(e.target.value)} />
            </CenterContainer>

            <CenterContainer>
                <button 
                    onClick={handleUpload} 
                    disabled={!file} >Upload</button>
            </CenterContainer>
 
            <CenterContainer>
                <p>{`Upload Status: ${status}`}</p>
            </CenterContainer>

            <CenterContainer> 
                {file ? <img src={previewUrl} alt="Uploaded preview" style={{ marginTop: '20px', maxWidth: '300px' }}  /> 
                    : <div>The uploaded image will appear here</div> }
            </CenterContainer>

        </div>
    );
}



export default function UploadModal({ show, handleSave, handleCancel }) {


    const [ urlInput, setUrlInput ] = React.useState('');
    const [ url, setUrl ] = React.useState(''); 
    const [ newFileData, setNewFileData ] = useState({}) 

    const handleChange = (event) => {
        setUrlInput(event.target.value);
        if (event.target.value) {
            setUrl(event.target.value);
        }
    };

    const handleUploadComplete = (response_data) => {
        console.log('Upload successful, server responded with: ' + JSON.stringify(response_data))   
        const urlFromResponse = `${CDN_URI}/${response_data.project}/files/${response_data.name}`; // Adjust this based on your actual response structure
        setNewFileData(response_data)
        setUrl(urlFromResponse);
    }
 

    return (
        <> 
            <Modal show={show} onHide={handleCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <div>
                     <lablel for="url-input">URL:</lablel>
                    <input id="url-input" value={urlInput} onChange={handleChange} />
                   </div> 
                <div>
                    <Uploader handleComplete={handleUploadComplete}  /> 
                </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancel}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => handleSave(url) }>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

